import { randomBytes } from 'node:crypto';
import kebabCase from 'lodash/kebabCase.js';
import { InvalidArgumentError } from '@commander-js/extra-typings';

const INVALID_PROJECT_SLUG_MESSAGE =
  'The business name must include at least one English letter or number so we can generate a valid project URL.';

export function isProjectSlugValid(name: string) {
  const projectSlug = getProjectSlugBase(name);

  if (!projectSlug) {
    throw new InvalidArgumentError(INVALID_PROJECT_SLUG_MESSAGE);
  }
}

function getProjectSlugBase(name: string) {
  return (
    kebabCase(name)
      // URL safe characters only
      .replaceAll(/[^a-z0-9-]/gi, '')
      // Drop any leading separators before truncation so valid ASCII suffixes survive.
      .replace(/^-+/, '')
      .slice(0, 10)
      .replace(/-+$/, '')
  );
}

export function generateProjectSlug(name: string) {
  const base = getProjectSlugBase(name);

  if (!base) {
    throw new Error(INVALID_PROJECT_SLUG_MESSAGE);
  }

  const salt = randomBytes(4).toString('hex');

  return `${base}-${salt}`;
}
